import { useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
// Material Dashboard 2 React components
import Switch from "@mui/material/Switch";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import Swal from "sweetalert2";
import { LanguageContext } from "App";
import { UserContext } from "App";
import GenerateReceiptButton from "CinicComponents/GenerateReceiptButton";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import AccountingApi from "../../../Classes/API/AccountingApi";
import PayAmountForDomesticStayReq from "../../../Classes/Models/Requests/Accounting/PayAmountForDomesticStayReq";
import AddManyToManyReq from "../../../Classes/Models/Requests/AddManyToManyReq";
import "./stay-detailes-style.scss";
import SearchStringOrIntReq from "../../../Classes/Models/Requests/SearchStringOrIntReq";
const StayDetailsCard = ({
  Stay,
  setShowAddSession,
  setIsLoaded,
  setShowAddExtra,
  setShowAddExtraSession,
  showAccountingSessions,
  setShowAccountingSessions,
  showExtraAccountingSessions,
  setShowExtraAccountingSessions,
  setShowExtrasTable,
  ShowExtras,
}) => {
  let User = useContext(UserContext);
  let navigate = useNavigate();
  const { translations } = useContext(LanguageContext);
  const [ShowPayPrice, setShowPayPrice] = useState(false);
  const [ShowPayOverHeadPrice, setShowPayOverHeadPrice] = useState(false);
  const [ShowPayInsurancePrice, setShowPayInsurancePrice] = useState(false);
  const [ShowPayInsuranceRefund, setShowPayInsuranceRefund] = useState(false);
  const [ShowPayExtraPrice, setShowPayExtraPrice] = useState(false);
  const [ShowPayExtraAccSessionPrice, setShowPayExtraAccSessionPrice] = useState(false);
  const [ShowPayAccSessionPrice, setShowPayAccSessionPrice] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");

  const [PayTotalPrice, setPayTotalPrice] = useState(0);
  const [PayPrice, setPayPrice] = useState(0);
  const [PayOverHeadPrice, setPayOverHeadPrice] = useState(0);
  const [PayInsurancePrice, setPayInsurancePrice] = useState(0);
  const [PayInsuranceRefund, setPayInsuranceRefund] = useState(0);
  const [PayExtraPrice, setPayExtraPrice] = useState(0);
  const [PayExtraAccountingSessionPrice, setPayExtraAccountingSessionPrice] = useState(0);
  const [PayAccountingSessionPrice, setPayAccountingSessionPrice] = useState(0);

  const TotalPrice =
    Stay.price +
    Stay.insurancePrice +
    Stay.extrasPrice +
    Stay.extraAccountingSessionsPrice +
    (Stay.overHeadPrice ? Stay.overHeadPrice : 0) +
    (Stay.accountingSessionsPrice ? Stay.accountingSessionsPrice : 0);
  const TotalPricePaid =
    Stay.pricePaid +
    Stay.insurancePricePaid +
    Stay.extrasPricePaid +
    Stay.extraAccountingSessionsPricePaid +
    Stay.overHeadPricePaid +
    (Stay.accountingSessionsPricePaid ? Stay.accountingSessionsPricePaid : 0);
  const TotalPriceToPay = TotalPrice - TotalPricePaid;

  const ToggleActivation = async () => {
    let req = new SearchStringOrIntReq();
    req.SearchInt = Stay.id;

    let res = await AccountingApi.ToggleDomesticStayActivation(req);
    if (res.status == "Success") {
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const ToggleCalculation = async () => {
    let req = new SearchStringOrIntReq();
    req.SearchInt = Stay.id;

    let res = await AccountingApi.ToggleDomesticStayCalculation(req);
    if (res.status == "Success") {
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const PayAmountForStay = async (PaymentType) => {
    Swal.fire({
      icon: "info",
      title: "Please wait",
      text: "Processing payment",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      didOpen: async () => {
        Swal.showLoading();
      },
    });
    let AmountToPay = 0;
    let _paymentType = "";
    let use = false;
    switch (PaymentType) {
      case "PayTotalPrice":
        if (!paymentMethod) {
          Swal.fire({
            title: "Error",
            text: "Select Payment Method",
            icon: "error",
            confirmButtonText: "Ok",
            didOpen: async () => {
              Swal.hideLoading();
            },
          });
          return;
        }
        AmountToPay = PayTotalPrice;
        _paymentType = "TotalPrice";
        break;
      case "PayPrice":
        AmountToPay = PayPrice;
        _paymentType = "RoomPrice";
        use = true;
        break;
      case "PayInsurancePrice":
        AmountToPay = PayInsurancePrice;
        _paymentType = "InsurancePrice";
        break;
      case "PayExtraPrice":
        AmountToPay = PayExtraPrice;
        _paymentType = "ExtrasPrice";
        use = true;
        break;
      // case "ExtraAccountingSessionsPrice":
      //     AmountToPay = PayExtraAccountingSessionPrice;
      //     _paymentType = "ExtraAccountingSessionsPrice";
      //     break;
      // case "AccountingSessionsPrice":
      //     AmountToPay = PayAccountingSessionPrice;
      //     _paymentType = "AccountingSessionsPrice";
      //     break;
      case "InsuranceRefund":
        AmountToPay = PayInsuranceRefund;
        _paymentType = "InsuranceRefund";
        break;
      case "OverHeadPrice":
        AmountToPay = PayOverHeadPrice;
        _paymentType = "OverHeadPrice";
        use = true;
        break;
      default:
        break;
    }

    if (AmountToPay == 0) {
      Swal.fire({
        title: "Error",
        text: "Please enter a payment amount",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    let PayAmountForDomestStayReq = new PayAmountForDomesticStayReq();
    PayAmountForDomestStayReq.Amount = AmountToPay;
    PayAmountForDomestStayReq.PaymentType = _paymentType;
    PayAmountForDomestStayReq.DomesticStayId = Stay.id;
    PayAmountForDomestStayReq.CreatorId = User.id;
    PayAmountForDomestStayReq.paymentMethod = paymentMethod;
    var res = null;
    if (use) {
      res = await AccountingApi.UseAmountForDomesticStay(PayAmountForDomestStayReq);
    } else {
      res = await AccountingApi.PayAmountForDomesticStay(PayAmountForDomestStayReq);
    }

    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Payment Successful",
        icon: "success",
        confirmButtonText: "Ok",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const CalculateSessionsPrice = async () => {
    let req = new SearchStringOrIntReq();
    req.SearchInt = Stay.id;
    let res = await AccountingApi.CalculateDomesticStaySessionsPrice(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: res.message,
        icon: "success",
        confirmButtonText: "Ok",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const RemoveAccountingSession = async (Session) => {
    let req = new AddManyToManyReq();
    req.Id1 = Stay.id;
    req.Id2 = Session.id;
    var res = await AccountingApi.RemoveAccountingSessionFromDomesticStay(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Session " + Session.id + " Removed",
        icon: "success",
        toast: true,
        position: "bottom-right",
        timer: 1800,
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const RemoveExtraAccountingSession = async (Session) => {
    let req = new AddManyToManyReq();
    req.Id1 = Stay.id;
    req.Id2 = Session.id;
    var res = await AccountingApi.RemoveExtraAccountingSessionFromDomesticStay(req);
    if (res.status == "Success") {
      Swal.fire({
        title: "Success",
        text: "Session " + Session.id + " Removed",
        icon: "success",
        toast: true,
        position: "top-right",
      });
      setIsLoaded(false);
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  const handleChange = (event) => {
    setPaymentMethod(event.target.value);
  };

  return (
    <>
      <Card sx={{ height: "100%", boxShadow: !false && "none", marginBottom: "2em" }}>
        <MDBox
          className="stay-info-header"
          mb={2}
          pt={2}
          px={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <MDTypography variant="h6" fontWeight="medium">
            {translations.StayInfoStayInfo}
          </MDTypography>
          <div>{/* <GenerateReceiptButton Stay={Stay} ReceiptType="Stay" /> */}</div>
        </MDBox>

        {(Stay.isTwoDayChecked || Stay.isHalfTimeChecked) && (
          <div style={{ textAlign: "center" }}>
            <span className="badge badge-danger mb-3 badge-header">
              {translations.StayInfoautomatically}
            </span>
          </div>
        )}

        <div className="row m-4">
          <div className="col-md-4 mt-3">
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              {translations.StayInfoStayId}: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Stay.id}
            </MDTypography>
          </div>

          <div className="col-md-4 mt-3">
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              {translations.StayInfoPatientName}: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Stay.getPatient.getUser.name}
            </MDTypography>
          </div>

          <div className="col-md-4 mt-3">
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              {translations.StayInfoStayisActive}: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Stay.isActive ? "Yes" : "No"}
            </MDTypography>

            <Switch checked={Stay.isActive} onChange={() => ToggleActivation()} />
          </div>

          <div className="col-md-4 mt-3">
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              {translations.StayInfoNotes}: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Stay.notes}
            </MDTypography>
          </div>

          <div className="col-md-4 mt-3">
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              {translations.StayInfoStartDate}: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Stay.startDate.split("T")[0]}
            </MDTypography>
          </div>

          <div className="col-md-4 mt-3">
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              {translations.StayInfoEndDate}: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Stay.endDate.split("T")[0]}
            </MDTypography>
          </div>

          <div className="col-md-4 mt-3">
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              {translations.StayInfoRoomType}: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Stay.roomType}
            </MDTypography>
          </div>

          <div className="col-md-4 mt-3">
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              {translations.StayInfoRoomId}: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Stay.roomId}
            </MDTypography>
          </div>

          <div className="col-md-4 mt-3">
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              {translations.StayInfoNumberOfDays}: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Stay.numberOfDays}
            </MDTypography>
          </div>
          <div className="col-md-4 mt-3">
            <div className="row mb-3 ml-1">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoExtraSessionsRegistered}: &nbsp;
              </MDTypography>
            </div>
            <div className="row mb-3 ml-1">
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{Stay.getExtraAccountingSessions.length}
              </MDTypography>{" "}
            </div>
            <div className="row mb-3 ml-1">
              <MDButton
                size="small"
                onClick={() => {
                  setShowAccountingSessions(false);
                  setShowExtraAccountingSessions((prev) => !prev);
                }}
                color={showExtraAccountingSessions ? "primary" : "info"}
              >
                {showExtraAccountingSessions
                  ? translations.StayInfoRemove
                  : translations.StayInfoShowFullList}
              </MDButton>
            </div>
          </div>

          <div className="col-md-4 mt-3">
            <div className="row mb-3 ml-1">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoInsurancePriceRefunded}: &nbsp;
              </MDTypography>
            </div>
            <div className="row mb-3 ml-1">
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{Stay.insuranceRefundedAmount} (
                {((Stay.insuranceRefundedAmount / Stay.insurancePricePaid) * 100).toFixed(2)}%)
              </MDTypography>
            </div>

            {ShowPayInsuranceRefund ? (
              <MDBox>
                <MDInput
                  type="number"
                  defaultValue={PayInsuranceRefund}
                  onChange={(e) => setPayInsuranceRefund(e.target.value)}
                  label={translations.StayInfoInsuranceRefundAmount}
                  name="payInsuranceRefund"
                  id="payInsuranceRefund"
                />
                <MDButton
                  size="small"
                  onClick={() => {
                    PayAmountForStay("InsuranceRefund");
                  }}
                  color={"success"}
                >
                  {translations.StayInfoRefundInsurance}
                </MDButton>
                <MDButton
                  size="small"
                  onClick={() => {
                    setShowPayInsuranceRefund(false);
                  }}
                  color={"primary"}
                >
                  {translations.StayInfoCancel}
                </MDButton>
              </MDBox>
            ) : (
              <MDButton
                size="small"
                onClick={() => setShowPayInsuranceRefund(true)}
                color={"success"}
              >
                {translations.StayInfoRefundInsurance}
              </MDButton>
            )}
          </div>

          <div className="col-md-4 mt-3">
            <div className="row mb-3 ml-1">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoSessionsRegistered}: &nbsp;
              </MDTypography>
            </div>
            <div className="row mb-3 ml-1">
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{Stay.getAccountingSessions.length} out of {Stay.numberOfDays * 2} available
              </MDTypography>
            </div>
            <MDButton
              size="small"
              onClick={() => {
                setShowExtraAccountingSessions(false);
                setShowAccountingSessions((prev) => !prev);
              }}
              color={showAccountingSessions ? "primary" : "info"}
            >
              {showAccountingSessions
                ? translations.StayInfoRemove
                : translations.StayInfoShowFullList}
            </MDButton>
          </div>
          <div className="col-md-4 mt-3">
            <div className="row mb-3 ml-1">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoExtras}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{Stay.getExtras.length}
              </MDTypography>
            </div>

            <div className="row mb-3 ml-1">
              <MDButton
                size="small"
                onClick={() => {
                  setShowExtrasTable(!ShowExtras);
                }}
                color="info"
              >
                {translations.StayInfoShowAllExtras}
              </MDButton>
            </div>

            <div className="row mb-3 ml-1">
              <MDButton
                size="small"
                onClick={() => {
                  setShowAddExtra(true);
                }}
                color="success"
              >
                {translations.StayInfoAddExtraToStay}
              </MDButton>
            </div>
          </div>
          <div className="col-md-4 mt-5 ">
            <MDButton
              size="small"
              onClick={() => {
                setShowAddExtraSession(true);
              }}
              color={"success"}
            >
              {translations.StayInfoAddExtraSessionsToStay}
            </MDButton>
          </div>

          <div className="col-md-4 mt-5 ">
            <MDButton
              size="small"
              onClick={() => {
                setShowAddSession(true);
              }}
              color={"success"}
            >
              {translations.StayInfoAddSessionsToStay}
            </MDButton>
          </div>
        </div>
      </Card>

      <Card
        sx={{
          height: "100%",
          boxShadow: !false && "none",
          marginBottom: "2em",
          border: !false && "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "4px",
          padding: "1em",
        }}
      >
        <MDBox
          className="stay-info-header"
          mb={2}
          pt={2}
          px={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <MDTypography variant="h6" fontWeight="medium">
            {translations.StayInfoTotalPrices}
          </MDTypography>
          <div>
            <MDButton
              size="small"
              color={"success"}
              onClick={() => {
                PayAmountForStay("PayTotalPrice");
              }}
            >
              {translations.StayInfoPayTotalPrice}
            </MDButton>
          </div>
        </MDBox>

        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3 mt-3">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoTotalPrice}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                {/* &nbsp;{TotalPrice} */}
                {Stay.totalPrice}
              </MDTypography>
            </div>

            <div className="col-md-3 mt-3">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoTotalPricePaid}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                {/* &nbsp;{TotalPricePaid} */}
                {Stay.totalPricePaid}
              </MDTypography>
            </div>

            <div className="col-md-3 mt-3">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoPriceRemainingToPay}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                {/* &nbsp;{TotalPriceToPay} */}
                {Stay.totalPrice - Stay.totalPricePaid}
              </MDTypography>
            </div>

            <div className="col-md-3 mt-3">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoPriceUsed}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                {Stay.totalPriceUsed}
              </MDTypography>
            </div>

            <div className="col-md-3 mt-3">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoAbsentPrice}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                {Stay.getAccountingSessions
                  .filter((x) => x.isAbsent == true)
                  .map((x) => x.finalPrice)
                  .reduce((a, b) => a + b, 0) +
                  Stay.getExtraAccountingSessions
                    .filter((x) => x.isAbsent == true)
                    .map((x) => x.finalPrice)
                    .reduce((a, b) => a + b, 0)}
              </MDTypography>
            </div>

            <div className="col-md-3 mt-3">
              <MDInput
                type="number"
                defaultValue={PayTotalPrice}
                onChange={(e) => setPayTotalPrice(e.target.value)}
                label={translations.StayInfoTotalPriceAmount}
                name="payTotalPrice"
                id="payTotalPrice"
              />
            </div>
            <div className="col-md-3 mt-3">
              <select
                labelId="payment-selector-label"
                value={paymentMethod}
                onChange={handleChange}
                label="Payment Method"
              >
                <option value="" disabled selected>
                  {translations.SelectPaymentmethod}
                </option>
                <option value="Visa">{translations.SelectPaymentmethodvisa}</option>
                <option value="Cash">{translations.SelectPaymentmethodCash}</option>
                <option value="Bank-transfer">
                  {translations.SelectPaymentmethodBankTransfer}
                </option>
              </select>
            </div>
          </div>
        </div>
      </Card>
      <Card
        sx={{
          height: "100%",
          boxShadow: !false && "none",
          marginBottom: "2em",
          border: !false && "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "4px",
          padding: "1em",
        }}
      >
        <MDBox
          mb={2}
          pt={2}
          px={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <MDTypography variant="h6" fontWeight="medium">
            {translations.StayInfoManagementPrices}
          </MDTypography>
        </MDBox>

        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4 mt-3">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoRoomPrice}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{Stay.price}
              </MDTypography>
            </div>

            <div className="col-md-4 mt-3">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoOverHeadPrice}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{Stay.overHeadPrice}
              </MDTypography>
            </div>

            <div className="col-md-4 mt-3">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoExtrasPrice}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{Stay.extrasPrice}
              </MDTypography>
            </div>

            <div className="col-md-4 mt-3">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoInsurancePrice}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{Stay.insurancePrice}
              </MDTypography>
            </div>
            <div className="col-md-4 mt-3">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoCalculateeven}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{Stay.calculatePricesEvenStayIsDeactivated ? "Yes" : "No"}
              </MDTypography>

              <Switch
                checked={Stay.calculatePricesEvenStayIsDeactivated}
                onChange={() => ToggleCalculation()}
              />
            </div>
            <div className="col-md-4 mt-3"></div>

            <div className="col-md-3 mt-3 ">
              <div className="row mb-3 ml-1">
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  {translations.StayInfoRoomPriceUsed}: &nbsp;
                </MDTypography>
              </div>
              <div className="row mb-3 ml-1">
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;{Stay.pricePaid} ({((Stay.pricePaid / Stay.price) * 100).toFixed(2)}%)
                </MDTypography>
              </div>
              <div className="row mb-3 ml-1">
                {ShowPayPrice ? (
                  <MDBox>
                    <MDInput
                      defaultValue={PayPrice}
                      onChange={(e) => setPayPrice(e.target.value)}
                      type="number"
                      label="Pay Price"
                      name="payPrice"
                      id="payPrice"
                    />
                    <MDButton
                      size="small"
                      color={"success"}
                      onClick={() => {
                        PayAmountForStay("PayPrice");
                      }}
                    >
                      Use Price
                    </MDButton>
                    <MDButton
                      size="small"
                      color={"info"}
                      onClick={() => {
                        setShowPayPrice(false);
                      }}
                    >
                      {translations.StayInfoCancel}
                    </MDButton>
                  </MDBox>
                ) : (
                  <MDButton size="small" color={"success"} onClick={() => setShowPayPrice(true)}>
                    {translations.StayInfoUsePrice}
                  </MDButton>
                )}
              </div>
            </div>

            <div className="col-md-3 mt-3">
              <div className="row mb-3  ml-1">
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  {translations.StayInfoOverHeadPriceUsed}: &nbsp;
                </MDTypography>
              </div>
              <div className="row mb-3  ml-1">
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;{Stay.overHeadPricePaid} (
                  {((Stay.overHeadPricePaid / Stay.overHeadPrice) * 100).toFixed(2)}%)
                </MDTypography>
              </div>
              <div className="row mb-3  ml-1">
                {ShowPayOverHeadPrice ? (
                  <MDBox>
                    <MDInput
                      defaultValue={PayOverHeadPrice}
                      onChange={(e) => setPayOverHeadPrice(e.target.value)}
                      type="number"
                      label="Pay Price"
                      name="PayOverHeadPrice"
                      id="payOverHeadPrice"
                    />
                    <MDButton
                      size="small"
                      color={"success"}
                      onClick={() => {
                        PayAmountForStay("OverHeadPrice");
                      }}
                    >
                      {translations.StayInfoUseOH}
                    </MDButton>
                    <MDButton
                      size="small"
                      color={"info"}
                      onClick={() => {
                        setShowPayOverHeadPrice(false);
                      }}
                    >
                      {translations.StayInfoCancel}
                    </MDButton>
                  </MDBox>
                ) : (
                  <MDButton
                    size="small"
                    color={"success"}
                    onClick={() => setShowPayOverHeadPrice(true)}
                  >
                    {translations.StayInfoUseOH}
                  </MDButton>
                )}
              </div>
            </div>

            <div className="col-md-3 mt-3">
              <div className="row mb-3  ml-1">
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  {translations.StayInfoExtrasPriceUsed}: &nbsp;
                </MDTypography>
              </div>{" "}
              <div className="row mb-3  ml-1">
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;{Stay.extrasPricePaid} (
                  {((Stay.extrasPricePaid / Stay.extrasPrice) * 100).toFixed(2)}%)
                </MDTypography>
              </div>{" "}
              <div className="row mb-3  ml-1">
                {ShowPayExtraPrice ? (
                  <MDBox>
                    <MDInput
                      type="number"
                      defaultValue={PayExtraPrice}
                      onChange={(e) => setPayExtraPrice(e.target.value)}
                      label="Extra Amount"
                      name="payExtra"
                      id="payExtra"
                    />
                    <MDButton
                      size="small"
                      color={"success"}
                      onClick={() => {
                        PayAmountForStay("PayExtraPrice");
                      }}
                    >
                      {translations.StayInfoUseExtra}
                    </MDButton>
                    <MDButton
                      size="small"
                      color={"info"}
                      onClick={() => {
                        setShowPayExtraPrice(false);
                      }}
                    >
                      {translations.StayInfoCancel}
                    </MDButton>
                  </MDBox>
                ) : (
                  <MDButton
                    size="small"
                    color={"success"}
                    onClick={() => setShowPayExtraPrice(true)}
                  >
                    {translations.StayInfoUseExtra}
                  </MDButton>
                )}
              </div>
            </div>

            <div className="col-md-3 mt-3">
              <div className="row mb-3  ml-1">
                <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                  {translations.StayInfoInsurancePricePaid}: &nbsp;
                </MDTypography>
              </div>{" "}
              <div className="row mb-3  ml-1">
                <MDTypography variant="button" fontWeight="regular" color="text">
                  &nbsp;{Stay.insurancePricePaid} (
                  {((Stay.insurancePricePaid / Stay.insurancePrice) * 100).toFixed(2)}%)
                </MDTypography>
              </div>{" "}
              <div className="row mb-3  ml-1">
                {ShowPayInsurancePrice ? (
                  <MDBox>
                    <MDInput
                      type="number"
                      defaultValue={PayInsurancePrice}
                      onChange={(e) => setPayInsurancePrice(e.target.value)}
                      label="Insurance Amount"
                      name="payInsurance"
                      id="payInsurance"
                    />
                    <MDButton
                      size="small"
                      color={"success"}
                      onClick={() => {
                        PayAmountForStay("PayInsurancePrice");
                      }}
                    >
                      {translations.StayInfoPayInsurance}
                    </MDButton>
                    <MDButton
                      size="small"
                      color={"info"}
                      onClick={() => {
                        setShowPayInsurancePrice(false);
                      }}
                    >
                      {translations.StayInfoCancel}
                    </MDButton>
                  </MDBox>
                ) : (
                  <MDButton
                    size="small"
                    color={"success"}
                    onClick={() => setShowPayInsurancePrice(true)}
                  >
                    {translations.StayInfoPayInsurance}
                  </MDButton>
                )}
              </div>
            </div>
          </div>
        </div>
      </Card>

      <Card
        sx={{
          height: "100%",
          boxShadow: !false && "none",
          marginBottom: "2em",
          border: !false && "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "4px",
          padding: "1em",
        }}
      >
        <MDBox
          mb={2}
          pt={2}
          px={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <MDTypography variant="h6" fontWeight="medium">
            {translations.StayInfoSessionsPrices}
          </MDTypography>
        </MDBox>

        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4 mt-3">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoSessionsPrices}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{Stay.accountingSessionsPrice}
              </MDTypography>
            </div>

            <div className="col-md-4 mt-3">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoExtraSessionsPrice}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                &nbsp;{Stay.extraAccountingSessionsPrice}
              </MDTypography>
            </div>

            <div className="col-md-4 mt-3">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoSessionsPriceUsed}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                {/* {Stay.accountingSessionsPricePaid} */}
                {
                  // sum of all sessions price
                  Stay.getAccountingSessions
                    .filter((x) => x.isAdmitted == true || x.isAbsent == true)
                    .map((x) => x.finalPrice)
                    .reduce((a, b) => a + b, 0)
                }{" "}
                &nbsp; ({Stay.getAccountingSessions.filter((x) => x.isAbsent == true).length} Absent
                Sessions)
              </MDTypography>
            </div>

            <div className="col-md-4 mt-3">
              <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
                {translations.StayInfoExtraSessionsPriceUsed}: &nbsp;
              </MDTypography>
              <MDTypography variant="button" fontWeight="regular" color="text">
                {/* {Stay.extraAccountingSessionsPricePaid} */}
                {
                  // sum of all sessions price
                  Stay.getExtraAccountingSessions
                    .filter((x) => x.isAdmitted == true || x.isAbsent == true)
                    .map((x) => x.finalPrice)
                    .reduce((a, b) => a + b, 0)
                }{" "}
                &nbsp; ({Stay.getExtraAccountingSessions.filter((x) => x.isAbsent == true).length}{" "}
                Absent Sessions)
              </MDTypography>
            </div>

            <div className="col-md-4 mt-3"></div>

            <div className="col-md-4 mt-3"></div>
          </div>
        </div>
      </Card>
    </>
  );
};

export default StayDetailsCard;
